var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn mt-3 float-right",class:{'btn-outline-light': _vm.light, 'btn-outline-primary': !_vm.light},attrs:{"to":_vm.to}},[_vm._v(" 查看更多详情"),_c('b-icon-box-arrow-up-right',{staticClass:"p-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }